import { action, observable } from 'mobx'
import { task } from 'mobx-task'
import { ModalViewModel } from '@/infra/ModalViewModel'
import type { FilingYear } from '@/features/jobs/details/tax-type/tax-prep-organizer/models/TxfWorklayerJob'
import type { NavigationTarget } from '@/features/jobs/details/tax-type/tax-prep-organizer/TaxPrepOrganizerViewModel'

export interface SwitchYearDialogViewModelOptions {
  onSave: (navigateTo: NavigationTarget) => Promise<void>
  onNavigate: (year: FilingYear) => void
}

export class SwitchYearDialogViewModel {
  readonly modal = new ModalViewModel()

  @observable accessor targetYear: FilingYear | null = null

  constructor(private readonly _options: SwitchYearDialogViewModelOptions) {}

  @action.bound
  showDialog(year: FilingYear) {
    this.targetYear = year
    this.modal.show()
  }

  @action.bound
  closeDialog() {
    this.modal.close()
    this.targetYear = null
  }

  saveAndContinue = task.resolved(async () => {
    if (this.targetYear) {
      await this._options.onSave({ type: 'year', year: this.targetYear })
    }
    this.closeDialog()
  })

  @action.bound
  continueWithoutSaving() {
    if (this.targetYear) {
      this._options.onNavigate(this.targetYear)
    }
    this.closeDialog()
  }
}
